import React from 'react';
import { Text, Stack } from '@moda/om';
import AlertIcon from '@moda/icons/alert-16';
import { formatPrice } from '../../../lib/formatPrice';
import { OrderDetailsPaymentSources } from '../../OrderDetailsPaymentSources';
import { OrderDetailsMain } from '../../OrderDetailsMain';
import { OrderPaymentSummary } from '../../PaymentSummary';
import { OrderDetailsRewardsSummary } from '../../OrderDetailsRewardsSummary';
import { useOrderDetails } from '../useOrderDetails';
import '../OrderDetails.scss';

export const OrderDetailsDesktop: React.FC = () => {
  const { orderNumber, order, hasBillFailure } = useOrderDetails();

  if (!order) return null;

  return (
    <Stack space={4}>
      <Stack className="OrderDetails__summary" space={2}>
        <Stack direction="horizontal" space={8}>
          <Stack space={2}>
            <Text color="cement">Order Number</Text>
            <Text>{orderNumber}</Text>
          </Stack>

          <Stack space={2}>
            <Text color="cement">Order Date</Text>
            <Text> {new Date(order.attributes.createdAt).toDateString()} </Text>
          </Stack>

          <Stack space={2}>
            <Text color="cement">Order Total</Text>
            <Text>
              {formatPrice(
                order.attributes.totals.orderTotal.currency,
                order.attributes.totals.orderTotal.price
              )}
            </Text>
          </Stack>
        </Stack>

        {hasBillFailure && (
          <Stack space={1} direction="horizontal">
            <AlertIcon className="OrderDetails__error-icon" />
            <Text treatment="body2" color="code-red">
              We're sorry, your payment cannot be processed.
            </Text>
          </Stack>
        )}
      </Stack>

      <OrderDetailsPaymentSources />

      <Stack direction="horizontal" space={6}>
        <Stack className="OrderDetails__left" space={4}>
          <OrderDetailsMain />
        </Stack>

        <Stack className="OrderDetails__right" space={4}>
          <OrderPaymentSummary orderNumber={orderNumber} hasBillFailure={hasBillFailure} />
          <OrderDetailsRewardsSummary />
        </Stack>
      </Stack>
    </Stack>
  );
};
